import axios from 'axios'
import Vue from 'vue'

export const state = {
  group: {
    id: null,
    info: null,
    onlineRoles: {},
    onlineUsers: {},
  },
  role: { name: 'unset' },
  onlineQueue: [],
}
export const getters = {
  role: state => {
    return state.role
  },
  group: state => {
    return state.group
  },
  onlineRoles: state => {
    return state.group.onlineRoles
  }
}

export const actions = {
  getRole: ({ commit, rootState }) => {
    axios
      .post('/api/pcs/role', {
        params: {
          pcs: localStorage.getItem('pcs'),
          classId: rootState.auth.classId
        },
      })
      .then(response => {
        if (response !== null) {
          commit('SET_ROLE', response.data[0])
        } else {
          commit('SET_ROLE', { name: 'student', role_id: 3 })
        }
      })
  },

  getGroup: ({ commit, dispatch, rootState, state }) => {
    axios
      .post('/api/group/info', {
        params: {
          pcs: localStorage.getItem('pcs'),
          classId: rootState.auth.classId,
        },
      })
      .then(response => {
        if (response.data) {
          let groupInfo = response.data
          axios.post('/api/get_role_map', {
            params: {
              group: groupInfo.id
            }
          }).then(response => {
            groupInfo.roles = response.data
            commit('SET_GROUP', groupInfo)
            while (state.onlineQueue.length > 0) {
              let action = state.onlineQueue.pop()
              dispatch(action.actionType, action.data)
            }
          })
        } else {
          commit('SET_GROUP', { id: null })
        }
        dispatch('getRole')
      })
  },
  
  updateOnlineRoles(context, users) {
    let onlineRoles = {}
    if (!context.state.group.info) {
      context.commit("ADD_ROLE_TO_PROCESS", { actionType: "updateOnlineRoles", data: users })
    }
    else {
      context.commit("UPDATE_ONLINE_USERS", users)
      users.forEach(user => {
        let roleName = context.state.group.info.roles[user.id]
        onlineRoles[roleName] = true
      })
      context.commit("UPDATE_ONLINE_ROLES", onlineRoles)
    }
  },

  addOnlineRole(context, userId) {
    if (!context.state.group.info) {
      context.commit("ADD_ROLE_TO_PROCESS", { actionType: "addOnlineRole", data: userId })
    }
    else {
      context.commit("ADD_ONLINE_USER", userId)
      if (context.rootState.events.pcs.role_based) {
        let roleName = context.state.group.info.roles[userId]
        context.commit("ADD_ONLINE_ROLE", roleName)
      }
    }
  },

  removeOnlineRole(context, userId) {
    if (!context.state.group.info) {
      context.commit("ADD_ROLE_TO_PROCESS", { actionType: "removeOnlineRole", data: userId })
    }
    else {
      context.commit("REMOVE_ONLINE_USER", userId)
      if (context.rootState.events.pcs.role_based) {
        let roleName = context.state.group.info.roles[userId]
        context.commit("REMOVE_ONLINE_ROLE", roleName)
      }
    }
  },
}

export const mutations = {
  SET_ROLE: (state, content) => {
    state.role = content
  },

  SET_GROUP: (state, content) => {
    if(content){
      state.group.id = content.id 
      state.group.info = content 
    }
    else {
      state.group.id = null
      state.group.info = null
    }
  },

  UPDATE_ONLINE_USERS(state, users) {
    state.group.onlineUsers = users.map(user => user.id)
  },

  UPDATE_ONLINE_ROLES(state, payload) {
    state.group.onlineRoles = payload
  },

  ADD_ONLINE_USER(state, userId) {
    state.group.onlineUsers.push(userId)
  },

  ADD_ONLINE_ROLE(state, payload) {
    Vue.set(state.group.onlineRoles, payload, true)
  },

  REMOVE_ONLINE_USER(state, payload) {
    let index = state.group.onlineUsers.findIndex(userId => { return userId == payload })
    if (index > -1) {
      state.group.onlineUsers.splice(index, 1)
    }
  },

  REMOVE_ONLINE_ROLE(state, payload) {
    Vue.set(state.group.onlineRoles, payload, false)
  },

  ADD_ROLE_TO_PROCESS(state, payload) {
    state.onlineQueue.push(payload)
  },

  CLEAR_STATE: state => {
    state.group = { 
      id: null,
      info: null,
      onlineRoles: {},
      onlineUsers: {},
     }
    state.role = { name: 'unset' }
  },
}
